import {
  AUTH_EMAIL_PARAM,
  AUTH_MODE_PARAM,
  AUTH_PRODUCT_PARAM,
  AUTH_REASON_PARAM,
  AUTH_RESTRICTED_RETURN_TO_PREFIXES,
  AUTH_RETURN_TO_PARAM,
  AUTH_SOURCE_PARAM,
  AUTH_VIEW_PARAM,
} from 'common/constants/auth';

interface BuildAuthSearchParamsOptions {
  email?: string | null;
  mode?: string | null;
  product?: string | null;
  reason?: string | null;
  returnTo?: string | null;
  source?: string | null;
  view?: string | null;
}

export const sanitizeAuthReturnTo = (value?: string | null) => {
  if (!value || !value.startsWith('/')) {
    return null;
  }

  if (value.startsWith('//') || AUTH_RESTRICTED_RETURN_TO_PREFIXES.some(prefix => value.startsWith(prefix))) {
    return null;
  }

  return value;
};

export const buildAuthSearchParams = ({
  email,
  mode,
  product,
  reason,
  returnTo,
  source,
  view,
}: BuildAuthSearchParamsOptions = {}) => {
  const params = new URLSearchParams();

  if (view) {
    params.set(AUTH_VIEW_PARAM, view);
  }

  if (email) {
    params.set(AUTH_EMAIL_PARAM, email);
  }

  if (mode) {
    params.set(AUTH_MODE_PARAM, mode);
  }

  if (product) {
    params.set(AUTH_PRODUCT_PARAM, product);
  }

  const sanitizedReturnTo = sanitizeAuthReturnTo(returnTo);
  if (sanitizedReturnTo) {
    params.set(AUTH_RETURN_TO_PARAM, sanitizedReturnTo);
  }

  if (source) {
    params.set(AUTH_SOURCE_PARAM, source);
  }

  if (reason) {
    params.set(AUTH_REASON_PARAM, reason);
  }

  return params;
};

export const replaceSearchParamsIfChanged = (
  currentSearchParams: URLSearchParams,
  nextSearchParams: URLSearchParams,
  replaceSearchParams: (params: URLSearchParams) => void
) => {
  if (currentSearchParams.toString() === nextSearchParams.toString()) {
    return;
  }

  replaceSearchParams(nextSearchParams);
};
